import { render, staticRenderFns } from "./StockNews.vue?vue&type=template&id=9a826314&scoped=true&"
import script from "./StockNews.vue?vue&type=script&lang=js&"
export * from "./StockNews.vue?vue&type=script&lang=js&"
import style0 from "./StockNews.vue?vue&type=style&index=0&id=9a826314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a826314",
  null
  
)

component.options.__file = "StockNews.vue"
export default component.exports